import * as React from "react";
import { ReactElement } from "react";
import styled from "@mui/material/styles/styled";
import { Button, Theme } from "@mui/material";
import { useHistory, useLocation, useRouteMatch } from "react-router";
import { ClinicDashBoardRoute } from "../../clinic/ClinicRoutes";
import { removeTrailingSlash } from "fe-common/routes/removeTrailingSlash";
import { getCurrentEnumRoute } from "fe-common/routes/commonPathUtils";
import { ClinicColors } from "fe-web-components/styles/clinicTheme";
import clsx from "clsx";

//region [[ Styles ]]

const IconContainer = styled("div")(
  ({
    theme,
    "data-active": active,
  }: {
    theme?: Theme;
    "data-active"?: string;
  }) => ({
    "& svg": {
      filter: active === "true" ? "brightness(200%)" : "none",
    },
    fontSize: "none",
    display: "flex",
    justifyContent: "center",
  }),
);

const MenuButton = styled(Button)({
  color: ClinicColors.textMain,
  backgroundColor: "none",
  textTransform: "none",
  padding: "12px 28px",
  justifyContent: "start !important", //important required to override chat widget styling in the settings page
  fontSize: 16,
  "&.selected": {
    background: ClinicColors.selectedBg,
    color: ClinicColors.secondary,
  },
  // "&.menu-button": {
  //   textTransform: "capitalize",
  //   display: "flex",
  //   color: "#AEAAB9",
  //   "&.active": {
  //     color: "white",
  //   },
  //   alignItems: "center",
  //   justifyContent: "start",
  //   paddingLeft: "40px",
  //   position: "relative",
  //   fontWeight: 700,
  //   width: "100%",
  //   borderRadius: "0px",
  //   textAlign: "left",
  //   paddingTop: "10px",
  //   paddingBottom: "10px",
  //   marginBottom: "20px",
  // },
});

//endregion [[ Styles ]]

//region [[ Props ]]

export interface ClinicMenuItemProps {
  icon?: ReactElement;
  label: string;
  route: ClinicDashBoardRoute;
}

//endregion [[ Props ]]

//region [[ Functions ]]
//endregion [[ Functions ]]

export const ClinicMenuItem = ({ ...props }: ClinicMenuItemProps) => {
  const history = useHistory();

  const match = useRouteMatch();

  const location = useLocation();

  const path = removeTrailingSlash(match.url);

  const patientRoute = getCurrentEnumRoute(
    location.pathname,
    ClinicDashBoardRoute,
  ) as ClinicDashBoardRoute;

  const selected = patientRoute === props.route;

  const onClickMenu = () => {
    history.push(`${path}/${props.route}/`);
  };

  return (
    <MenuButton
      className={clsx("menu-button", selected ? "selected" : "")}
      onClick={onClickMenu}
      startIcon={
        <IconContainer data-active={selected ? "true" : "false"}>
          {props.icon}
        </IconContainer>
      }
    >
      {props.label}
    </MenuButton>
  );
};

export const ClinicMenuButton = (props: {
  label: string;
  onClick: () => void;
  icon?: ReactElement;
}) => {
  return (
    <MenuButton
      onClick={props.onClick}
      startIcon={<IconContainer>{props.icon}</IconContainer>}
    >
      {props.label}
    </MenuButton>
  );
};
